var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-container"},[_c('div',{staticClass:"p-shopMap"},[_c('div',{staticClass:"p-shopMap__inner"},[_c('div',{staticClass:"p-shopMap__frame"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.src,"width":"600","height":"450","allowfullscreen":"","loading":"lazy"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }